import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GoDot, GoDotFill } from 'react-icons/go'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { animated, interpolate, useSprings } from 'react-spring'

const WelcomeSection = () => {
	const { t } = useTranslation()

	const images = [
		{
			title1: t('welcome.optimalSolutions'),
			title2: t('welcome.trustAndSupport'),
			img: '/543212762.jpg',
		},
		{
			title1: t('welcome.developingStrategies'),
			title2: t('welcome.expertAdvice'),
			img: '/handshake.jpg',
		},
		{
			title1: t('welcome.ourExperience'),
			title2: t('welcome.stabilityAndReliability'),
			img: '/trucks.jpg',
		},
		{
			title1: t('welcome.tradingMarkets'),
			title2: t('welcome.agroExports'),
			img: '/traiding-markets-map.png',
		},
	]

	const [index, setIndex] = useState(0)

	const springs = useSprings(
		images.length,
		images.map((image, i) => ({
			transform: interpolate(
				[(i - index) * 100 + '%', (i - index + 1) * 100 + '%'],
				x => `translateX(${x})`
			),
		}))
	)

	const handlePrev = () => {
		setIndex(prevIndex => (prevIndex === 0 ? images.length - 1 : prevIndex - 1))
	}

	const handleNext = () => {
		setIndex(prevIndex => (prevIndex === images.length - 1 ? 0 : prevIndex + 1))
	}

	useEffect(() => {
		const timer = setTimeout(() => {
			setIndex(prevIndex =>
				prevIndex === images.length - 1 ? 0 : prevIndex + 1
			)
		}, 4500)
		return () => clearTimeout(timer)
	}, [index])

	return (
		<section className='welcome-section'>
			<div className='farm-img-overlay'>
				<div className='title'>
					<button className='arrow' onClick={handlePrev}>
						<IoIosArrowBack />
					</button>

					{springs.map((style, i) => (
						<animated.div
							key={i}
							className={`label`}
							style={{ ...style, position: 'absolute', width: '100%' }}
						>
							<h1>{images[i].title1}</h1>
							<h2>{images[i].title2}</h2>
						</animated.div>
					))}

					<button className='arrow' onClick={handleNext}>
						<IoIosArrowForward />
					</button>
				</div>
				<div className='img-bar'>
					{images.map((img, i) => (
						<div key={i} className='dot'>
							{i === index ? <GoDotFill className='active' /> : <GoDot />}
						</div>
					))}
				</div>
			</div>
			<div
				className='farm-img'
				style={{
					position: 'relative',
					width: '100%',
					overflow: 'hidden',
					objectFit: 'cover',
				}}
			>
				{springs.map((style, i) => (
					<>
						{!images[i].img.endsWith('traiding-markets-map.png') ? (
							<animated.div
								key={i}
								style={{
									...style,
									position: 'absolute',
									width: '100%',
									height: '100%',
									objectFit: 'cover',
								}}
							>
								<img
									src={images[i].img}
									alt={`Image ${i + 1}`}
									style={{ width: '100%', height: '100%', objectFit: 'cover' }}
								/>
							</animated.div>
						) : (
							<animated.div
								className='flex items-center justify-center'
								key={i}
								style={{
									...style,
									position: 'absolute',
									width: '100%',
									height: '100%',
								}}
							>
								<img
									className='max-w-[140%] xl:w-full'
									src={images[i].img}
									alt=''
								/>
							</animated.div>
						)}
					</>
				))}
			</div>
		</section>
	)
}

export default WelcomeSection
